import authRoutes from './Auth';
import dashboardRoutes from './Dashboard';

/* The code is creating an array called `Routes` that combines the elements of the `authRoutes` array
and the `dashboardRoutes` array. The spread operator (`...`) is used to spread the elements of each
array into the new array. */
const Routes = [...authRoutes, ...dashboardRoutes];

export default Routes;
